import VideoCard from "../../components/common/VideoCard";
import useSelectVideo from "../../hooks/useSelectVideo";
import { useLocation } from "react-router-dom";

export default function Trending({ loading, posts = [] }) {

    const location = useLocation();
    // Filter posts to only those with video_url
    const filterData = Array.isArray(posts) ? posts.filter((item) => item.video_url !== null) : [];
    const selectVideo = useSelectVideo();

    const handleSelectVideo = async (id) => {
        selectVideo(id, filterData, location.pathname, "trending");
    };

    return (
        <>
            {/* Heading for Trending Videos Section */}
            <div className="flex items-center justify-between p-2">
                <p className="text-[14px] font-bold text-blue-600 dark:text-white">Trending Videos</p>
            </div>
            {/* Trending Videos Section */}
            <div className="grid grid-cols-3 gap-1 overflow-scroll no-scrollbar px-2">
                {filterData?.map((data) => (
                    <VideoCard
                        key={data.id}
                        id={data.id}
                        body={data.body}
                        belowDecs={true}
                        threeDots={false}
                        video={data.video_url}
                        view_count={data.view_count}
                        likes_count={data.likes_count}
                        authorId={data.created_by?.id}
                        selectVideo={handleSelectVideo}
                        avatar_url={data.created_by.avatar_url}
                    />
                ))}
            </div>
            {filterData.length === 0 && !loading && (
                <div className="flex justify-center items-center h-[25dvh]">
                    <p className="text-[12px] text-gray-500">
                        No post found
                    </p>
                </div>
            )}
        </>
    );
}